"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
//@ts-ignore
function BiometricPermissionLogo(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 64, height: 64, viewBox: "0 0 64 64", fill: "none" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M29.264 35.131l-5.267-5.266c-.4-.4-.889-.6-1.466-.6-.578 0-1.067.2-1.467.6-.4.4-.6.889-.6 1.466 0 .578.2 1.067.6 1.467l6.6 6.6c.4.4.878.6 1.433.6.556 0 1.034-.2 1.434-.6l12.333-12.333c.356-.356.533-.823.533-1.4 0-.578-.177-1.045-.533-1.4-.355-.356-.811-.534-1.367-.534-.555 0-1.01.178-1.366.534L29.264 35.13zm2.733 23.334c-.177 0-.344-.012-.5-.034a2.468 2.468 0 01-.433-.1c-5.956-1.778-10.844-5.433-14.667-10.966-3.822-5.534-5.733-11.611-5.733-18.234V16.065c0-.845.245-1.612.733-2.3a4.228 4.228 0 011.867-1.5l17.333-6.467a4.095 4.095 0 011.4-.267c.445 0 .911.09 1.4.267l17.334 6.467a4.228 4.228 0 011.866 1.5c.49.688.734 1.455.734 2.3V29.13c0 6.623-1.911 12.7-5.734 18.234-3.822 5.533-8.71 9.188-14.666 10.966l-.934.134zm0-4c5.111-1.69 9.278-4.878 12.5-9.567 3.223-4.689 4.834-9.945 4.834-15.767V16.065L31.997 9.53l-17.333 6.534V29.13c0 5.822 1.611 11.078 4.833 15.767 3.223 4.689 7.39 7.878 12.5 9.567z", fill: "#109648" })));
}
exports.default = BiometricPermissionLogo;
//# sourceMappingURL=BiometricsPermissionLogo.js.map